export const POPOVER_CONFIGS = {
    '1': {
        type: 'gaep.popover_type.basic',
        desc: 'gaep.popover.desc.basic',
        content: [
            'gaep.popover.content.item.single',
            'gaep.popover.content.item.married',
            'gaep.popover.content.item.non_pregnant',
            'gaep.popover.content.item.families'
        ]
    },
    '2': {
        type: 'gaep.popover_type.comprehensive',
        desc: 'gaep.popover.desc.comprehensive',
        content: [
            'gaep.popover.content.item.student',
            'gaep.popover.content.item.pregnant',
            'gaep.popover.content.item.non_us_citizens',
            'gaep.popover.content.item.naturalized_citizens',
            'gaep.popover.content.item.missing_ssn',
            'gaep.popover.content.item.diff_names',
            'gaep.popover.content.item.incarcerated',
            'gaep.popover.content.item.foster_care',
            'gaep.popover.content.item.stepchildren',
        ]
    },
    '3': {
        type: 'gaep.popover_type.complex',
        desc: 'gaep.popover.desc.complex',
        content: [
            'gaep.popover.content.item.AI',
            'gaep.popover.content.item.AN',
            'gaep.popover.content.item.married_not_jointly',
            'gaep.popover.content.item.dependants',

        ]
    }
};